export interface ISearchBoxValue {
  key: string;
  operator: string;
  value: string;
  _id?: string;
}
